import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { Desktop, Mobile } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { BACKOFFICE_NAME } from '../../helpers/helperFunctions';
import {
  KYC_START,
  SETTINGS_SECURITY,
  SETTINGS_VIRTUAL_OFFICE,
  TRAVEL_PACKAGES
} from '../../routes/routes';
import { color } from '../../styles/GlobalStyles';
import { getDashboardInfo } from './Dashboard.actions';
import { PackageRankUpgradeNotification } from './Dashboard.types';
import { DashboardNotification } from './DashboardNotification';
import { EarningsComponent } from './EarningsComponent';
import { MoneyBack } from './MoneyBack';
import { NumberOfMembers } from './NumberOfMembers';

import { RankNotification } from './RankNotification';
import { StatisticalComponent } from './StatisticalComponent';
import { SubscriptionWarning } from './SubscriptionWarning';

import { WelcomeSidebar } from './WelcomeSidebar';

import flipMe from '../../assets/images/backoffice/flipMe/flipMeBanner.png';
import flipMeMobile from '../../assets/images/backoffice/flipMe/flipMeBannerMobile.png';

import licencesPromo from '../../assets/images/backoffice/licencesPromo/licencesPromo.png';
import licencesPromoMobile from '../../assets/images/backoffice/licencesPromo/licencesPromoMobile.png';

import bigWhaleBanner from '../../assets/images/backoffice/bigWhale/bigWhaleBanner.png';
import bigWhaleBannerMobile from '../../assets/images/backoffice/bigWhale/bigWhaleBannerMobile.png';

import travelBanner from '../../assets/images/backoffice/travelPackages/travelBanner.png';
import travelBannerMobile from '../../assets/images/backoffice/travelPackages/travelBannerMobile.png';

import { IconTitleStyled } from './DashboardStyled';

const Dashboard = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation('dashboard');
  const {
    user,
    kycStatus,
    isSideModalChecked,
    isCanadaRestrictedUser,

    canBuyTravelPackages
  } = useAppSelector((state) => state.auth.userInfo);

  const { dashboardInfo, joinedAfterCount, loading } = useAppSelector(
    (state) => state.dashboard
  );

  const [welcome, setWelcome] = useState(!isSideModalChecked);

  const history = useHistory();

  useEffect(() => {
    dispatch(getDashboardInfo());
  }, [dispatch]);

  const KycPackageNotifications = () => {
    if (!kycStatus?.isKycCompleted && !kycStatus?.isKycVerified) {
      return (
        <DashboardNotification
          pill={t('kyc_pill')}
          title={t('kyc_title')}
          text={t('kyc_text')}
          buttonOnClick={() => history.push(KYC_START)}
          buttonText={t('verify_now')}
        />
      );
    } else return null;
  };

  const StartYourJourneyNotification = () => {
    if (!dashboardInfo?.user?.currentVirtualOfficeLicence) {
      return (
        <DashboardNotification
          pill={'take the first step today'}
          title={'Start your Journey HERE!'}
          text={`To achieve the fastest growth, start with the MaVie ${BACKOFFICE_NAME} Subscription.`}
          buttonText={`Start with a ${BACKOFFICE_NAME}`}
          buttonOnClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}
        />
      );
    } else return null;
  };

  const SecurityNotification = () => {
    if (!dashboardInfo?.user?.settings?.signInEmailCodeVerificationEnabled) {
      return (
        <DashboardNotification
          titleColor={color.colors.error500}
          pill={t('notifications.security.pill')}
          title={t('notifications.security.title')}
          text={t('notifications.security.text')}
          buttonText={t('notifications.security.button')}
          buttonOnClick={() => history.push(SETTINGS_SECURITY)}
        />
      );
    } else return null;
  };

  if (loading && !dashboardInfo) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'dashboardInfo'}>
      <div style={{ margin: '70px 0' }}>
        <IconTitleStyled>{t('earnings.notifications')}</IconTitleStyled>

        <StartYourJourneyNotification />

        {dashboardInfo?.packageRankUpgradeNotifications?.map(
          (notification: PackageRankUpgradeNotification, index: number) => {
            return <RankNotification notification={notification} key={index} />;
          }
        )}

        <SubscriptionWarning />

        {canBuyTravelPackages && (
          <Link to={TRAVEL_PACKAGES}>
            <Desktop>
              <img
                src={travelBanner}
                alt='airdropBanner'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={travelBannerMobile}
                alt='airdropBannerMobile'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )}
        {/* 
        {!isCanadaRestrictedUser && (
          <Link to={SETTINGS_VIRTUAL_OFFICE}>
            <Desktop>
              <img
                src={licencesPromo}
                alt='licencesPromo'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={licencesPromoMobile}
                alt='licencesPromoMobile'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )} */}

        {/* FAST START BONUS */}
        {!isCanadaRestrictedUser && <MoneyBack />}

        {/* MY OVERVIEW */}
        <EarningsComponent user={user} backOffice={dashboardInfo} />
        {/* STATISTICAL DATA */}
        <StatisticalComponent backOffice={dashboardInfo} />
        {/* <UnilevelDashboard /> */}

        {/* <ExclusiveGaming /> */}
        {/* <Exclusive /> */}

        <KycPackageNotifications />

        <SecurityNotification />

        <NumberOfMembers backOffice={dashboardInfo} count={joinedAfterCount} />
      </div>
      {!isCanadaRestrictedUser && (
        <WelcomeSidebar open={welcome} setOpen={setWelcome} />
      )}
    </AnimatedDashboard>
  );
};

export default Dashboard;
